/** The manual's address for a page (and a part of it): `#/help/timeline:markers`. */
export const helpHref = (doc?: string, part?: string) => `#/help${doc ? `/${doc}${part ? `:${part}` : ''}` : ''}`;
